module.exports = __webpack_public_path__ + "static/media/PerdidaEMBARAZO.255beda3.svg";